import React from 'react';
import './Events.css';
import mapPinIcon from '../map-pin.png';
import calendarIcon from '../calendar.png';
import purposeImage from '../purpose.png';
import foundationImage from '../foundation.png';
import windIcon from '../wind.png';
import shellIcon from '../shell.png';
import userStarIcon from '../user-star.png';
import sunIcon from '../sun.png';
import weightIcon from '../weight.png';
import knifeIcon from '../knife.png';
import yogaIcon from '../yoga.png';
import slide3Image from '../slide3.png';
import heartIcon from '../heart.png';
import markIcon from '../mark.png';
import fireIcon from '../fire.png';
import compassIcon from '../call.png';
import mapAboutIcon from '../location.png';
import card4Image from '../card4.png';
import pcIcon from '../pc.png';

const Events = () => {
  return (
    <div className="events-page">
      {/* Hero Section */}
      <section className="events-hero-section">
        <div className="events-hero-overlay">
          <div className="events-hero-content">
            <h1 className="events-main-title">
              <span className="title-line-1">Sanatan Jagaran</span>
              <span className="title-line-2">
                <span className="title-white">Rashtra </span>
                <span className="title-orange">Kalyan Yagya Yatra</span>
              </span>
            </h1>
            <p className="events-description">
              Join the sacred journey to revive Sanatan values, establish national welfare, and spread the light 
              of Vedas across the nation. A 42-day spiritual marathon traversing 15 states.
            </p>
            <div className="events-details">
              <div className="event-detail">
                <img src={mapPinIcon} alt="Location" className="detail-icon" />
                <span className="detail-text">Rameshwaram ➜ Srinagar</span>
              </div>
              <div className="event-detail">
                <img src={calendarIcon} alt="Date" className="detail-icon" />
                <span className="detail-text">14 Jan 2026 ➜ 24 Feb 2026</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Purpose Section */}
      <section className="purpose-section">
        <div className="container">
          <div className="purpose-content">
            <div className="purpose-header">
              <div className="purpose-line"></div>
              <h2 className="purpose-title">Purpose of the Yagya Yatra</h2>
            </div>
            
            <p className="purpose-description">
              To awaken the consciousness of the nation, purify the environment through 
              Yagya, and re-establish the glory of Vedic culture in the hearts of millions.
            </p>
            
            <div className="purpose-image">
              <img src={purposeImage} alt="Purpose of the Yagya Yatra Statistics" />
            </div>
          </div>
        </div>
      </section>

     

      {/* Vision & Objectives Section */}
      <section className="vision-objectives-section">
        <div className="container">
          <div className="vision-objectives-content">
            <div className="vision-objectives-header">
              <div className="vision-objectives-line"></div>
              <h2 className="vision-objectives-title">Vision & Objectives</h2>
            </div>
            
            <p className="vision-objectives-description">
              Our mission is rooted in the timeless wisdom of the Vedas, aiming for 
              universal peace and prosperity.
            </p>
            
            <div className="objectives-grid">
              <div className="objective-card">
                <div className="objective-icon">
                  <img src={heartIcon} alt="Revival of Sanatan Values" />
                </div>
                <div className="objective-content">
                  <h3 className="objective-title">Revival of Sanatan Values</h3>
                  <p className="objective-description">
                    Restoring the core ethical and spiritual foundations 
                    of Sanatan Dharma in modern society for a 
                    harmonious life.
                  </p>
                </div>
              </div>
              
              <div className="objective-card">
                <div className="objective-icon">
                  <img src={markIcon} alt="Rashtra Kalyan" />
                </div>
                <div className="objective-content">
                  <h3 className="objective-title">Rashtra Kalyan</h3>
                  <p className="objective-description">
                    Promoting national unity, integrity, and welfare 
                    through the collective power of spiritual 
                    awakening.
                  </p>
                </div>
              </div>
              
              <div className="objective-card">
                <div className="objective-icon">
                  <img src={fireIcon} alt="Akhand Jyoti Establishment" />
                </div>
                <div className="objective-content">
                  <h3 className="objective-title">Akhand Jyoti Establishment</h3>
                  <p className="objective-description">
                    Lighting the eternal flame of knowledge and 
                    sacrifice in every heart and home across 
                    Bharat.
                  </p>
                </div>
              </div>
              
              <div className="objective-card">
                <div className="objective-icon">
                  <img src={pcIcon} alt="Vedic Education Awareness" />
                </div>
                <div className="objective-content">
                  <h3 className="objective-title">Vedic Education Awareness</h3>
                  <p className="objective-description">
                    Spreading awareness about the scientific and 
                    spiritual relevance of Vedic education 
                    (Gurukulam system).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
       {/* Yagya Foundation Section */}
      <section className="yagya-foundation-section">
        <div className="container">
          <div className="yagya-foundation-content">
            <div className="foundation-image">
              <img src={foundationImage} alt="Yagya - The Foundation of Balance" />
            </div>
            
            <div className="foundation-text">
              <div className="foundation-header">
                <div className="foundation-line"></div>
                <h2 className="foundation-title">Yagya - The Foundation of Balance</h2>
              </div>
              
              <p className="foundation-description">
                Yagya is not merely a ritual; it is the science of purification and the art of 
                selfless living. It harmonizes the individual with the cosmos.
              </p>
              
              <div className="foundation-points">
                <div className="foundation-point">
                  <div className="point-icon">
                    <img src={windIcon} alt="Environmental Purification" />
                  </div>
                  <div className="point-content">
                    <h3 className="point-title">Environmental Purification</h3>
                    <p className="point-description">
                      The medicinal smoke from Yagya purifies the atmosphere, 
                      eliminating harmful bacteria and pollutants.
                    </p>
                  </div>
                </div>
                
                <div className="foundation-point">
                  <div className="point-icon">
                    <img src={shellIcon} alt="Spiritual Elevation" />
                  </div>
                  <div className="point-content">
                    <h3 className="point-title">Spiritual Elevation</h3>
                    <p className="point-description">
                      Chanting of Vedic mantras creates vibrations that calm the 
                      mind and elevate consciousness.
                    </p>
                  </div>
                </div>
                
                <div className="foundation-point">
                  <div className="point-icon">
                    <img src={userStarIcon} alt="Selfless Sacrifice" />
                  </div>
                  <div className="point-content">
                    <h3 className="point-title">Selfless Sacrifice (Idam Na Mama)</h3>
                    <p className="point-description">
                      Teaching the principle of "This is not for me," fostering a spirit 
                      of detachment and service.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sanatan Dharma Through Time Section */}
      <section className="dharma-time-section">
        <div className="container">
          <div className="dharma-time-content">
            <div className="dharma-time-header">
              <div className="dharma-time-line"></div>
              <h2 className="dharma-time-title">Sanatan Dharma Through Time</h2>
            </div>
            
            <div className="yuga-cards">
              <div className="yuga-card">
                <div className="yuga-icon">
                  <img src={sunIcon} alt="Satya Yuga" />
                </div>
                <h3 className="yuga-title">Satya Yuga</h3>
                <p className="yuga-description">
                  The era of truth and perfection. Dharma stands 
                  on four legs. Purity reigns supreme.
                </p>
              </div>
              
              <div className="yuga-card">
                <div className="yuga-icon">
                  <img src={weightIcon} alt="Treta Yuga" />
                </div>
                <h3 className="yuga-title">Treta Yuga</h3>
                <p className="yuga-description">
                  The era of ritual sacrifice. Virtue diminishes slightly. 
                  The age of Sri Rama.
                </p>
              </div>
              
              <div className="yuga-card">
                <div className="yuga-icon">
                  <img src={knifeIcon} alt="Dwapara Yuga" />
                </div>
                <h3 className="yuga-title">Dwapara Yuga</h3>
                <p className="yuga-description">
                  The era of duality. Forces of good and evil struggle. The 
                  age of Sri Krishna.
                </p>
              </div>
              
              <div className="yuga-card">
                <div className="yuga-icon">
                  <img src={yogaIcon} alt="Kali Yuga" />
                </div>
                <h3 className="yuga-title">Kali Yuga</h3>
                <p className="yuga-description">
                  The current age. A time for revival through Naam 
                  Sankirtan and Yagya to restore Dharma.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Journey Route Section */}
      <section className="journey-route-section">
        <div className="container">
          <div className="journey-route-content">
            <div className="journey-route-header">
              <div className="journey-route-line"></div>
              <h2 className="journey-route-title">Journey Route</h2>
            </div>
            
            <p className="journey-route-description">
              Traversing the length of Bharat, touching the hearts of millions across 16 states.
            </p>
            
            <div className="states-grid">
              <div className="state-row">
                <div className="state-tag">Madhya Pradesh</div>
                <div className="state-tag">Uttar Pradesh</div>
                <div className="state-tag">Delhi</div>
                <div className="state-tag">Haryana</div>
                <div className="state-tag">Punjab</div>
                <div className="state-tag">Uttarakhand</div>
                <div className="state-tag">Himachal Pradesh</div>
                <div className="state-tag">Jammu & Kashmir</div>
              </div>
              
              <div className="state-row">
                <div className="state-tag">Tamil Nadu</div>
                <div className="state-tag">Andhra Pradesh</div>
                <div className="state-tag">Telangana</div>
                <div className="state-tag">Karnataka</div>
                <div className="state-tag">Kerala</div>
                <div className="state-tag">Maharashtra</div>
                <div className="state-tag">Gujarat</div>
                <div className="state-tag">Rajasthan</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Organizers Section */}
      <section className="organizers-section">
        <div className="container">
          <div className="organizers-content">
            <div className="organizers-grid">
              <div className="organizer-card">
                <div className="organizer-icon">
                  <img src={sunIcon} alt="Vishwa Kalyan Charitable Trust" />
                </div>
                <h3 className="organizer-title">Vishwa Kalyan Charitable Trust</h3>
                <p className="organizer-role">Organizer</p>
                <p className="organizer-description">
                  Dedicated to the welfare of the world through charitable 
                  activities, educational initiatives, and the propagation of Vedic 
                  knowledge.
                </p>
              </div>
              
              <div className="organizer-card">
                <div className="organizer-icon">
                  <img src={yogaIcon} alt="Shri Narendra Ji" />
                </div>
                <h3 className="organizer-title">Shri Narendra Ji</h3>
                <p className="organizer-role">Yagya Sutra Acharya</p>
                <p className="organizer-description">
                  A renowned Vedic scholar and spiritual leader guiding the Yatra 
                  with his profound knowledge and unwavering dedication to 
                  Sanatan Dharma.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Be a Part of the Sanatan Jagaran Movement</h2>
            <div className="cta-buttons">
              <button className="cta-button">
                <img src={compassIcon} alt="Contact Us" className="cta-button-icon" />
                Contact Us
              </button>
              <button className="cta-button">
                <img src={mapAboutIcon} alt="Visit Gurukulam" className="cta-button-icon" />
                Visit Gurukulam
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Events;